import { render, staticRenderFns } from "./BrandVerify.vue?vue&type=template&id=736b2d17&scoped=true"
import script from "./BrandVerify.vue?vue&type=script&lang=js"
export * from "./BrandVerify.vue?vue&type=script&lang=js"
import style0 from "./BrandVerify.vue?vue&type=style&index=0&id=736b2d17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736b2d17",
  null
  
)

export default component.exports